// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"43307fba","453":"011e2d34","732":"3540f111"}[chunkId] + ".chunk.js";
};